import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

import { adminAPIURL, customHeaders } from '../../../../../Containers/Config/index.js';
import apiCall from '../../../apiCall.js';
import { CREATE_GOLF_INVENTORY, CREATE_GOLF_INVENTORY_ERROR, CREATE_GOLF_INVENTORY_SUCCESS } from '../../../../actions.js';
import cogoToast from 'cogo-toast';

function* createGolfInventory({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const formData = new FormData();
    formData.append('golf_inventory_upload_type', payload?.data?.golf_inventory_upload_type);
    formData.append('file', payload?.data?.file);

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v1/golf-inventory/create`,
      method: 'POST',
      headers: {
        ...filteredHeaders,
      },
      isFormData: true,
      data: formData,
    });

    if (response.status === 200) {
      cogoToast.success(response?.data?.message);
      yield put({
        type: CREATE_GOLF_INVENTORY_SUCCESS,
        payload: response?.data,
      });
    } else {
      cogoToast.error(response?.response?.data?.message);
      yield put({
        type: CREATE_GOLF_INVENTORY_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: CREATE_GOLF_INVENTORY_ERROR, payload: error });
  }
}

export function* watchCreateGolfInventory() {
  yield takeEvery(CREATE_GOLF_INVENTORY, createGolfInventory);
}

function* createGolfInventorySaga() {
  yield all([fork(watchCreateGolfInventory)]);
}

export default createGolfInventorySaga;
